import { useNavigation, useUrlContext } from '@msdk/common'
import { sanitizeuUrl } from '@msdk/ui/src/components/Markdown/url-sanitizer'
import { Link } from '@mui/material'
import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

import { getAdditionalContextFromLink, navigateToLink } from './LinkNotificationUtils'

export interface Props {
  children: ReactNode | ReactNode[]
  href: string | undefined
  tenant: string
}

export function NotificationLink({ children, href, tenant }: Props) {
  const navigate = useNavigation()
  const reactNavigate = useNavigate()
  const urlContext = useUrlContext()

  const isRelativeUrl = (href as string)?.includes('##tenantBaseUrl##') //##tenantBaseUrl## is used only to understand if it's a relative url or not
  const url = sanitizeuUrl((href as string)?.replaceAll('##tenantBaseUrl##', ''))

  const openLink = async (link: string) => {
    const additionalCtx = isRelativeUrl ? getAdditionalContextFromLink(link) : undefined
    navigateToLink(link, isRelativeUrl, urlContext.context.sitemap, tenant, navigate, reactNavigate, additionalCtx)
  }

  return (
    <Link underline="none" rel="noreferrer" onClick={() => openLink(url)}>
      {children}
    </Link>
  )
}
